import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTrash(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM8 9h8v10H8V9Zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
